import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarService } from '../shared/services/sidebar.service';
import { GisFocusService } from '../shared/services/gis-focus.service';
import { GeospatialMapBridgeService } from '../shared/services/geospatial-map-bridge.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit, OnDestroy {
  isSidebarExpanded = true;
  /** Full-bleed GIS/map routes: no outer padding, no scroll on outlet (shell manages its own layout). */
  isMapEditorRoute = false;
  isGisFocusMode = false;
  private sidebarSubscription: Subscription;
  private routerSubscription?: Subscription;
  private focusSubscription?: Subscription;

  constructor(
    private sidebarService: SidebarService,
    private gisFocus: GisFocusService,
    private geoMapBridge: GeospatialMapBridgeService,
    private router: Router
  ) {
    this.sidebarSubscription = this.sidebarService.isExpanded$.subscribe(
      expanded => {
        this.isSidebarExpanded = expanded;
      }
    );
  }

  ngOnInit(): void {
    this.updateMapEditorRoute(this.router.url);
    this.routerSubscription = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => this.updateMapEditorRoute(e.urlAfterRedirects));
    this.focusSubscription = this.gisFocus.isFocusMode$.subscribe((on) => {
      this.isGisFocusMode = on;
      this.refreshMapAfterChromeChange();
    });
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Escape' || !this.isGisFocusMode) return;
    if (event.defaultPrevented || this.gisFocus.isDrawingEscCaptured()) return;
    this.gisFocus.exit();
  }

  private updateMapEditorRoute(url: string): void {
    this.isMapEditorRoute = GisFocusService.isGisMapUrl(url);
    if (!this.isMapEditorRoute) {
      this.gisFocus.setDrawingEscCaptured(false);
      this.gisFocus.exit();
    }
  }

  private refreshMapAfterChromeChange(): void {
    requestAnimationFrame(() => {
      [50, 120, 350].forEach((ms) =>
        setTimeout(() => this.geoMapBridge.refreshMapSize(), ms)
      );
    });
  }

  ngOnDestroy(): void {
    this.sidebarSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this.focusSubscription?.unsubscribe();
  }
}
